import { AuthSplitLayout } from '../components/auth/layout/AuthSplitLayout';
import { LoginLeftPanel } from '../components/auth/login/LoginLeftPanel';
import { LoginRightPanel } from '../components/auth/login/LoginRightPanel';

/**
 * Split-screen login page with form on left and branding on right.
 */
export default function LoginPage() {
  return (
    <AuthSplitLayout
      left={<LoginLeftPanel />}
      right={<LoginRightPanel />}
    />
  );
}
